import React from 'react';
import { Menu, MenuItem, Sidebar } from 'react-pro-sidebar';
import sideBarMenu from './menu';
import { useNavigate } from 'react-router-dom';
// import sidebarIcon from '../../../assets/icons/KGF_logo_sidebar.svg';
import GoldPulseLogo from '../../../assets/images/goldpulse_logo.png';
import { Tooltip } from 'antd';

interface Props {
  collapsed: boolean;
  role: string;
  toggleSidebar: () => void;
}

export default function SidebarComponent({
  collapsed,
  role,
  toggleSidebar,
}: Props) {
  const navigate = useNavigate();

  const handleTo = (to: string) => {
    navigate(to);
  };

  const filteredMenu = sideBarMenu.filter(
    (item: {
      label: string;
      to: string;
      icons: {
        inActive: JSX.Element;
        active: JSX.Element;
      };
    }) => {
      if (role === 'Admin') return true;

      const allowedRoles = {
        Overview: ['manager', 'auditor', 'superadmin', 'cashier', 'billing'],
        'Bank Pledge': ['manager', 'cashier', 'superadmin', 'approver'],
        Loan: ['manager', 'billing', 'superadmin', 'cashier', 'approver'],
        Customer: ['manager', 'billing', 'superadmin', 'cashier'],
        Transactions: ['manager', 'cashier', 'superadmin'],
        Deposits: ['manager', 'superadmin', 'cashier'],
        'Interest Scheme': ['superadmin'],
        Users: ['Admin', 'superadmin'],
        Investment: ['superadmin'],
        Recovery: ['superadmin', 'manager', 'billing', 'recovery'],
        Terms: ['manager', 'auditor', 'superadmin', 'cashier', 'billing'],
        'Bank Guide': [
          'manager',
          'auditor',
          'superadmin',
          'cashier',
          'billing',
        ],
        Reports: ['superadmin', 'auditor'],
        'Cash Bank Book': ['cashier'],
        Sale: ['manager', 'billing', 'superadmin', 'cashier', 'approver'],
        Settings: ['superadmin'],
      };

      return allowedRoles[item.label as keyof typeof allowedRoles]?.includes(
        role
      );
    }
  );

  return (
    <Sidebar collapsed={collapsed} className="sidebar">
      <div className="image__header">
        <img src={GoldPulseLogo} width={100} height={100} />
      </div>
      <div className="sidebar-menu-scroll">
        <Menu>
          {filteredMenu.map((item) => {
            const isActive = location.pathname === item.to;
            const currentIcon = isActive
              ? item.icons.active
              : item.icons.inActive;
            return (
              <Tooltip
                key={item.label}
                title={collapsed ? item.label : ''}
                placement="right"
                mouseEnterDelay={0}
                mouseLeaveDelay={0}
                overlayInnerStyle={{
                  fontSize: '0.75rem',
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 500,
                  borderRadius: '6px',
                  padding: '5px 10px',
                }}
              >
                <MenuItem
                  className={`list-item ${isActive ? 'list-item-active' : ''}`}
                  key={item.label}
                  icon={currentIcon}
                  onClick={() => {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                    handleTo(item.to);
                  }}
                >
                  {item.label}
                </MenuItem>
              </Tooltip>
            );
          })}
        </Menu>
      </div>
      <div className="colltoggle" onClick={toggleSidebar}>
        {collapsed ? (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 6L15 12L9 18"
              stroke="#333"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ) : (
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 6L9 12L15 18"
              stroke="#333"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>{' '}
    </Sidebar>
  );
}
